import React from 'react';

import { BLOCKS } from '@contentful/rich-text-types';
import { S } from 'src/components-v2/StyledElements/StyledElements';

const HorizontalRule = ({ hr }) => {
  return {
    [BLOCKS.HR]: (node) => {
      return <S.Hr {...hr} />;
    },
  };
};

export default HorizontalRule;
